
import { Component, Vue } from 'vue-property-decorator';

import Form8ProcessHeader from "@/components/process/Form8/components/Form8ProcessHeader.vue";
import Form8StyleOfProceeding from "@/components/process/Form8/components/Form8StyleOfProceeding.vue";
import { form8StatusInfoType } from '@/types/Information/Form8';

@Component({
    components:{
        Form8ProcessHeader,        
        Form8StyleOfProceeding
    }
})
export default class FillForm8 extends Vue {

    stepsCompleted = {} as form8StatusInfoType;   

    mounted() {  
        this.stepsCompleted = {
            first: false,
            second: false,
            third: false
        }       
    }
}
